import { APP_INITIALIZER, ApplicationConfig, importProvidersFrom } from '@angular/core';
import { provideRouter } from '@angular/router';
import { provideAnimations } from '@angular/platform-browser/animations';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { provideHttpClient } from '@angular/common/http';
import { routes } from './app.routes';
import { EnvironmentService } from '@angular-monorepo/environment';
import { environment } from '../environments/environment';

export const appConfig: ApplicationConfig = {
  providers: [
    provideRouter(routes),
    provideAnimations(),
    importProvidersFrom(BrowserAnimationsModule),
    provideHttpClient(),
    {
      provide: APP_INITIALIZER,
      useFactory: (configService: EnvironmentService) => () => configService.setConfig(environment),
      deps: [EnvironmentService],
      multi: true,
    },
  ],
};
